export const environment = {
	production: false,

	api: {
		host: 'https://appapidev.pointhealthtech.com',
	},

	billNegotiation: {
		baZingPlanCode: 'PL-C46DA1C9',
		defaultPlanCode: 'PL-A8BD741B',
	},

	stripe: {
		publishableKey: 'pk_test_51HZimCKtqDXmWNvw6jjpiqzM7X4wJiGumVOxVl5tswq62lP4ExaFeKASifgaUp9DOdoqPyp22AZXUdpMGW9WQm7A00SXoZSPTS',
	},
};
